export class RestoreMicrosoft365TeamRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "Microsoft365TeamRestoreScope",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "Microsoft365TeamSelectedItemsOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365TeamRequest.attributeTypeMap;
    }
    constructor() {
    }
}
